import $ from './components/jquery-global';
import { Tooltip, Dropdown, Popover } from 'bootstrap';
import { Notyf } from 'notyf';
import customSelect from './components/select';
import { generateAvatar } from './components/avatar';
import { setupLanguageSwitcher } from './components/languageSwitcher';
import { Cookie } from './components/cookies';
import { setupThemeSwitcher } from './components/theme-switcher';

const notyf = new Notyf({
    duration: 4000,
    position: { x: 'right', y: 'top' },
});
window.notyf = notyf;

$(function () {

    $('[data-bs-toggle="tooltip"]').each(function () {
        new Tooltip(this);
    });

    setupThemeSwitcher();

    if (djangoData.username && $('.user-avatar').length) {
        generateAvatar({ name: djangoData.username });
        $('#userNameDesktop').html($('#dropdownUserInfo').html());
        $('#userEmailDesktop').text($('#userEmail').text());
        if ($('.app-user-bar__plan').length) {
            $('#userPlanDesktop').html($('.app-user-bar__plan').html());
        }
        if ($('.app-user-bar__paused').length) {
            $('#userPausedDesktop').html($('.app-user-bar__paused').html());
        }
    }

    if (djangoData.authToken) {
        Cookie.set('statusAuth', 'login');
        Cookie.set('statusAuthPlan', djangoData.currentPlan);
        Cookie.set('statusAuthToken', djangoData.authToken);
    } else {
        Cookie.erase('statusAuth');
        Cookie.erase('statusAuthPlan');
        Cookie.erase('statusAuthToken');
    }

    function toggleDropdownMenu() {
        const $nav = $('.navbar-nav');
        if (window.innerWidth < 1800) {
            $nav.addClass('dropdown-menu dropdown-menu-end');
        } else {
            $nav.removeClass('dropdown-menu dropdown-menu-end');
        }
    }
    toggleDropdownMenu();
    $(window).on('resize', toggleDropdownMenu);

    if (djangoData.username && $('.app-sidebar').length) {
        $('.app-sidebar__toggle').on('click', function () {
            $('.app-sidebar').toggleClass('app-sidebar--show');
            $('.app-page').toggleClass('app-page--hide-sidebar');
            $(this).toggleClass('app-sidebar__toggle--hide');
            $('.app-sidebar__close').toggleClass('d-none');
        });

        $('.app-sidebar__close').on('click', function () {
            $('.app-sidebar').removeClass('app-sidebar--show');
            $(this).addClass('d-none');
        });

        $(window).on('resize', function () {
            if (window.matchMedia('(min-width: 1199.98px)').matches) {
                $('.app-sidebar').removeClass('app-sidebar--show');
                $('.app-sidebar__close').addClass('d-none');
            }
        });
    }

    $(document).on('click', '.btn-clipboard', function () {
        const $btn = $(this);
        const $target = $btn.siblings('.copy-to-clipboard');
        const text = ($target.is('input, textarea') ? $target.val() :
            $target.text()).trim();

        if (!text) return;

        navigator.clipboard.writeText(text).then(function () {
            const $popup = $btn.siblings('.popup-copied');
            if ($popup.length) {
                $popup.show();
                setTimeout(() => $popup.hide(), 1500);
            } else {
                notyf.success('Copied!');
            }
        });
    });

    setupLanguageSwitcher(djangoData.languageCode);

    $('#header-language-list .language-list__item').on('click', function (e) {
        e.preventDefault();
        Cookie.set('pageUserLanguage', $(this).data('lang'), { expires: 365, path: '/' });
        window.location.href = $(this).attr('href');
    });

    $('.btn-with-spinner').on('click', function () {
        $(this).addClass('disabled opacity-100').find('.spinner-border').removeClass('d-none');
    });

    $(window).on('pageshow', function () {
        $('.btn-with-spinner').each(function () {
            $(this).removeClass('disabled').find('.spinner-border').addClass('d-none');
        });
    });
});
